module.exports = __webpack_public_path__ + "static/media/Step 6-Species.4726cfc8.png";